import moment from 'moment';
import fp from 'lodash/fp';
import * as actions from './actions';
import * as constants from './constants';
import { combineColumnPreferences } from '../../common/saveconfiguration/utils';

export const INITIAL_STATE = {
    columns: [
        {
            id: 'imModel',
            visible: true
        },
        {
            id: 'silo',
            visible: true
        },
        {
            id: 'riskClass',
            visible: true
        },
        {
            id: 'senstivity',
            visible: true
        },
        {
            id: 'bucket',
            visible: true
        },
        {
            id: 'trades',
            visible: true
        },
        {
            id: 'imPledgeUsd',
            visible: true
        },
        {
            id: 'imReceiveUsd',
            visible: true
        },
        {
            id: 'imPledgeEur',
            visible: true
        },
        {
            id: 'imReceiveEur',
            visible: true
        }
    ],

    csaDrilldownRows: [],
    defaultFilters: constants.defaultFilters,
    filterDefinitions: constants.filterDefinitions,
    initialised: false,
    loading: false,
    lastUpdated: moment().unix(),
    currentServerFilters: []
};

const setCsaDrilldown = fp.set('csaDrilldownRows');
const setLoading = fp.set('loading');
const setColumns = fp.set('columns');
const setInitialised = fp.set('initialised');

export default function reducer(state = INITIAL_STATE, action = {}) {
    switch (action.type) {
        case actions.SET_INITIALISED: {
            return setInitialised(action.initialised, state);
        }
        case actions.TOGGLE_ROW_EXPANDED: {
            return {
                ...state,
                csaDrilldownRows: state.csaDrilldownRows.map(
                    row => (row.id === action.data
                        ? { ...row, expanded: !row.expanded }
                        : row)
                )
            };
        }
        case actions.SET_LOADING: {
            return setLoading(action.loading, state);
        }
        case actions.SET_DEFAULT_CONFIG: {
            return {
                ...state,
                columns: action.columns && action.columns.length
                    ? combineColumnPreferences(INITIAL_STATE.columns, action.columns)
                    : INITIAL_STATE.columns
            };
        }
        case actions.FETCH_CSADRILLDOWN_SUCCEEDED: {
            return {
                ...state,
                csaDrilldownRows: action.data,
                lastUpdated: moment().unix(),
                currentServerFilters: action.serverFilters
            };
        }
        case actions.FETCH_CSADRILLDOWN_FAILED: {
            return setCsaDrilldown([], state);
        }
        case actions.SET_CSADRILLDOWN_COLUMNS: {
            return setColumns(
                combineColumnPreferences(INITIAL_STATE.columns, action.data),
                state
            );
        }
        case actions.SET_ALL_EXPANDED: {
            return {
                ...state,
                csaDrilldownRows: state.csaDrilldownRows.map(
                    e => (e.level === 0
                        || e.level === 3 ? { ...e, expanded: action.data } : { ...e })
                )
            };
        }
        default:
            return state;
    }
}
